import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {LoginService} from '../../../shared/services/login.service';
import {Router, ActivatedRoute} from '@angular/router';
import {UploadFileComponent} from '../../../shared/components/upload-file/upload-file.component';
import {Steps} from 'primeng/primeng';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ServiceBase} from '../../../shared/services/service-base';
import {WorkrequestLndWComponent} from '../workrequest-lnd-w/workrequest-lnd-w.component';
import {LndW} from '../lnd-w';
import {LndWService} from '../lnd-w.service';
import {WorkrequestLndWViewmodel} from '../workrequest-lnd-w-viewmodel';
import {OwnerDetailsComponent} from '../../../shared/components/owner-details/owner-details.component';
import {LndBaseComponent} from './lnd-base.component';
import {WorkrequestLndWDetails} from '../workrequest-lnd-w-details';
import {Meta} from '@angular/platform-browser';

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-lnd-w',
  templateUrl: 'lnd-w.component.html',
  styleUrls: ['lnd-w.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, WorkrequestLndWComponent,
    UploadFileComponent, IppaymentComponent, OwnerDetailsComponent],
  encapsulation: ViewEncapsulation.None
})

export class LndWComponent extends LndBaseComponent<LndW> implements OnInit {
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/pfi.png';

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestLndWComponent;

  constructor(protected loginService: LoginService,
              protected lndwService: LndWService, protected ipPaymentService: IppaymentService, protected router: Router, private route: ActivatedRoute, private meta: Meta) {
    super(loginService, lndwService, ipPaymentService, router);
    this.applicationType = 'lnd-w';
    this.meta.updateTag({ name: 'description', content: 'Extend and/or upgrade a Greater Western Water sewer and/or water main.' });
  }

  async ngOnInit() {
    super.ngOnInit();
    
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.setupGuestRedirectUrl();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.setupGuestRedirectUrl();
      this.setupTabs();
    }
  }

  setupGuestRedirectUrl(): void {
    if(this.route.snapshot.data['fromUrl'] === 'lnd-w-guest') {
      //this.loginService.guestLogin((ok: boolean)=>{
        this.router.navigate(['/lnd-w']);
      //});
    }
  }

  setupTabs(): void {
    // this.initSteps('Location details', 'Development', 'Upload files',
    //   'Developer (Owner)', 'Consultant', 'Review and submit',
    //   'Payment');
    this.initSteps('Location details', 'Development', 'Upload files',
      'Developer (Owner)', 'Consultant', 'Review and submit');
  }

  subscribePaymentInit() {
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(6, this.workrequestComponent.totalOrderAmount);
    });
  }

  setDescriptionOfWork() {
    (<LndW>this.lndwService.applicationData).workrequestDetails.setDescriptionOfWork();
  }

  set formalPlanOfSubdivision(v: boolean) {
    this.lndwService.formalPlanOfSubdivision = v;
  }

  get formalPlanOfSubdivision(): boolean {
    return this.lndwService.formalPlanOfSubdivision;
  }

  get overallDevelopmentPlan(): boolean {
    return this.lndwService.overallDevelopmentPlan;
  }

  set overallDevelopmentPlan(v: boolean) {
    this.lndwService.overallDevelopmentPlan = v;
  }

  get planIndicatingServiceLayout(): boolean {
    return this.lndwService.planIndicatingServiceLayout;
  }

  set planIndicatingServiceLayout(v: boolean) {
    this.lndwService.planIndicatingServiceLayout = v;
  }

  get workRequestViewModel(): WorkrequestLndWViewmodel {
    return <WorkrequestLndWViewmodel>this.lndwService.workRequestViewModel;
  }

  get displayCCWarning(): boolean {
    // return this.isGuestUserLoggedIn && !this.isPaymentByCheque;
    return !this.loginService.isUserBillLater() && !this.isPaymentByCheque;
  }

  get displayPayByChequeEFTMessage(): boolean {
    // return this.isGuestUserLoggedIn && this.isPaymentByCheque;
    return !this.loginService.isUserBillLater() && this.isPaymentByCheque;
  }

  navigateFromWorkRequest(executeYes: any, executeNo: any): void {
    this.workrequestComponent.errorMessage = null;
    if (this.workrequestComponent.displayErrorMessage().length > 0) {
      this.workrequestComponent.displayErrorMessage();
      executeNo();
    } else {
      executeYes();
    }
  }

  navigateFromUploadFiles(executeYes: any, executeNo: any) {
    if (!this.uploadFileComponent.isValid) {
      executeNo();
    } else {
      let hasError = false;

      if (!this.formalPlanOfSubdivision) {
        this.lndwService.submitErrorMessage += 'Please confirm attachment of formal plan of subdivision.' + '<br>';
        hasError = true;
      }

      if (!this.overallDevelopmentPlan) {
          this.lndwService.submitErrorMessage += 'Please confirm attachment of overall development plan.' + '<br>';
          hasError = true;
      }
      if (!this.planIndicatingServiceLayout) {
          this.lndwService.submitErrorMessage += 'Please confirm attachment of plan indicating proposed services layout.' + '<br>';
          hasError = true;
      }

      if (hasError) {
        executeNo();
      } else {
        executeYes();
      }
    }
  }

  setWorkRequestData() {
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).planOfSubdivisionNumber = this.location.addressDetails.plan;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).lotNumber = this.location.addressDetails.lot;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).streetName = this.location.addressDetails.street;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).unitNumber = this.location.addressDetails.unitNumber;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).streetNumber = this.location.addressDetails.streetNumber;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).streetType = this.location.addressDetails.streetTypeId;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).streetSuffixType = this.location.addressDetails.streetSuffixTypeId > -1 ? this.location.addressDetails.streetSuffixTypeId : null;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).suburb = this.location.addressDetails.suburb;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).postCode = this.location.addressDetails.postCode;
    (<LndW>this.lndwService.applicationData).workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
  }

  validateWorkRequest(validData: boolean) {
    this.workrequestComponent.errorMessage = null;
    if (this.workrequestComponent.displayErrorMessage().length > 0) {
      this.lndwService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      validData = false;
    }
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.isPaymentByCheque = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/lnd-w/lnd-w.component.ts